module.exports = __webpack_public_path__ + "img/seven_step.e2707d77.png";